const MandatoryIcon = () => {
  return (
    <span>
      <svg
        width="16px"
        height="16px"
        viewBox="0 0 16 16"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fillRule="evenodd">
          <polygon
            id="Shape"
            fill="#EE2E24"
            fillRule="nonzero"
            points="7.17184265 4 8.82815735 4 8.5010352 7.164 11.1718427 5.308 12 6.692 9.00207039 8 12 9.308 11.1718427 10.692 8.5010352 8.836 8.82815735 12 7.17184265 12 7.4989648 8.836 4.82815735 10.692 4 9.308 6.99792961 8 4 6.692 4.82815735 5.308 7.4989648 7.164"
          ></polygon>
        </g>
      </svg>
    </span>
  );
};

export default MandatoryIcon;
